import {type FC, type PropsWithChildren, lazy} from 'react'
import {createPortal} from 'react-dom'

import {experiments} from 'src/shared/config'
import {appConfig} from 'src/shared/config/app-config'

const GutsRevealerComponent = lazy(() => import('@yandex-delivery/guts-revealer'))

export const GutsRevealer: FC<PropsWithChildren> = () => {
  if (experiments.shouldShowGutsRevealer) {
    return createPortal(<GutsRevealerComponent experiments={appConfig.experiments3} />, document.body)
  }
}
GutsRevealer.displayName = 'Providers_GutsRevealer'
